<template>
  <div>
    <div class="courseConfigration">
      <b-row>
        <b-col md="12">
          <b-overlay :show="loadData" rounded="sm">
            <template #overlay>
              <b-icon
                icon="stopwatch"
                variant="info"
                scale="3"
                shift-v="8"
                shift-h="8"
                class="reportIcon"
              ></b-icon>
            </template>
            <!-- <div class="selectReportType mb-2 d-flex justify-content-center">
              <b-form-radio v-model="reportType" :value="0"
                >Oridinary Report</b-form-radio
              >
              <b-form-radio v-model="reportType" :value="1" class="ml-3"
                >ISO Report</b-form-radio
              >
            </div> -->
            <div v-if="!loadConfigData">
              <div class="attendence">
                <AttendenceConfig
                  ref="attendenceConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :classTypes="classTypes"
                  :selectedClassTypesProp="selectedClassTypes"
                />
              </div>
              <br />
              <div class="ml-2">
                <div class="attendence border border-info rounded p-2">
                  <div class="">
                    <b-row>
                      <b-col>
                        <div class="">
                          <b-form-checkbox
                            class="ml-2"
                            v-model="activity_simple_calculation"
                            @change="updateActivitySimpleCalculation"
                          >
                            <p class="btn p-0 m-0 text-info">
                              Simple activity score calculation
                            </p>
                          </b-form-checkbox>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="">
                          <b-form-checkbox
                            class=""
                            v-model="remove_weigtage_column"
                            @change="updateActivitySimpleCalculation"
                          >
                            <p class="btn p-0 m-0 text-info">
                              Remove weigtage column from report
                            </p>
                          </b-form-checkbox>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="">
                          <b-form-checkbox class="" v-model="description_page">
                            <p class="btn p-0 m-0 text-info">
                              Description page
                            </p>
                          </b-form-checkbox>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="">
                          <b-form-checkbox
                            class=""
                            v-model="final_score_rounding"
                          >
                            <p class="btn p-0 m-0 text-info">
                              Roundup Final Score
                            </p>
                          </b-form-checkbox>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="">
                          <b-form-checkbox
                            class=""
                            v-model="final_score_roundup"
                          >
                            <p class="btn p-0 m-0 text-info">
                              Final score rounded up to next integer (eg: 11.2
                              => 12)
                            </p>
                          </b-form-checkbox>
                        </div>
                      </b-col>
                    </b-row>
                    <p v-if="activity_simple_calculation" class="m-1">
                      Score of assessments of a student = score for activities *
                      sum(score of student in activity) / sum(max. score of
                      activity)
                    </p>
                    <p v-if="!activity_simple_calculation" class="m-1">
                      Calculations details available in downloaded report
                    </p>
                  </div>
                </div>
              </div>
              <br />

              <div class="assignment"
              v-if="selectedActivityTypes.includes('assignment')">
                <AssignmentConfig
                  ref="assignmentConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
              
             
              <div class="assessment"
              v-if="selectedActivityTypes.includes('assessment')">
                <AssessmentConfig
                  ref="assessmentConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
              

              <div class="assessment"
              v-if="selectedActivityTypes.includes('flipped_class')">
                <FlippedClassConfig
                  ref="flippedClassConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
             

              <div class="assessment"
              v-if="selectedActivityTypes.includes('listening_task')">
                <ListeningTaskConfig
                  ref="listeningTaskConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
             

               <div class="assessment"
              v-if="selectedActivityTypes.includes('models')">
                <ModelsConfig
                  ref="modelsConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
             

              <div class="assessment"
              v-if="selectedActivityTypes.includes('quiz')">
                <QuizConfig
                  ref="quizConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
            

              
              <div class="assessment"
              v-if="selectedActivityTypes.includes('reading_task')">
                <ReadingTaskConfig
                  ref="readingTaskConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
             

              <div class="assessment"
              v-if="selectedActivityTypes.includes('speaking_task')">
                <SpeakingTaskConfig
                  ref="speakingTaskConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
            

               <div class="assessment"
              v-if="selectedActivityTypes.includes('writing_task')">
                <WritingTaskConfig
                  ref="writingTaskConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
                <br />
              </div>
             

              <div class="assessment border border-info rounded p-2">
                <div
                  class="checkAssignment d-flex justify-content-between align-items-baseline mb-2"
                >
                  <b-row>
                    <b-col class="sm-12">
                      <div class="d-flex">
                        <b-form-checkbox class="ml-2" v-model="classparticipantCheckBox">
                          <p class="btn p-0 m-0 text-info">Class Participation</p>
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="sm-6">
                      <div class="" v-if="classparticipantCheckBox">
                        <label class="required" for="scoreForClassparticipant"
                          >Score:</label
                        >
                        <b-form-input
                          id="scoreForClassparticipant"
                          v-model="classparticipantScore"
                          placeholder="Enter Score"
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <br />

              <div class="assessment border border-info rounded p-2">
                <div
                  class="checkAssignment d-flex justify-content-between align-items-baseline mb-2"
                >
                  <b-row>
                    <b-col class="sm-12">
                      <div class="d-flex">
                        <b-form-checkbox class="ml-2" v-model="seminarCheckBox">
                          <p class="btn p-0 m-0 text-info">Seminar</p>
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="sm-6">
                      <div class="" v-if="seminarCheckBox">
                        <label class="required" for="scoreForSeminar"
                          >Score:</label
                        >
                        <b-form-input
                          id="scoreForSeminar"
                          v-model="seminarScore"
                          placeholder="Enter Score"
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <br />

              <div class="assessment">
                <SeminarConfig
                  ref="seminarConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
              </div>
              <br />

              <div class="border border-info rounded p-2">
                <b-form-checkbox class="ml-2" v-model="laboratory.checkLab">
                  <p class="btn p-0 m-0 text-info">Laboratory</p>
                </b-form-checkbox>

                <div v-if="laboratory.checkLab">
                  <b-row>
                    <b-col class="sm-6" role="group">
                      <label class="required" for=""
                        >Score for Continuous Assessment:</label
                      >
                      <b-form-input
                        id=""
                        v-model="laboratory.assessmentScore"
                        placeholder="Enter Score"
                      ></b-form-input>
                    </b-col>

                    <b-col class="sm-6" role="group">
                      <label class="required" for=""
                        >Score for Internal Test:</label
                      >
                      <b-form-input
                        id=""
                        v-model="laboratory.internalTestScore"
                        placeholder="Enter Score"
                      ></b-form-input>
                    </b-col>

                    <b-col class="sm-6" role="group">
                      <label class="required" for=""
                        >Score for Viva voce:</label
                      >
                      <b-form-input
                        id=""
                        v-model="laboratory.vivaVoceScore"
                        placeholder="Enter Score"
                      ></b-form-input>
                    </b-col>

                    <b-col class="sm-6" role="group">
                      <label class="required" for="">Score for Record:</label>
                      <b-form-input
                        id=""
                        v-model="laboratory.recordScore"
                        placeholder="Enter Score"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <br />

              <div class="border border-info rounded p-2">
                <b-row>
                  <b-col>
                    <b-form-checkbox class="ml-2" v-model="project.enable">
                      <p class="btn p-0 m-0 text-info">Project</p>
                    </b-form-checkbox></b-col
                  >
                  <b-col v-if="project.enable">
                    <div class="sm-6" role="group">
                      <label class="required" for="">Score for Project:</label>
                      <b-form-input
                        id=""
                        v-model="project.score"
                        placeholder="Enter Score"
                      ></b-form-input>
                    </div> </b-col
                ></b-row>
              </div>
              <br />
              <div class="assessment">
                <ProjectConfig
                  ref="projectConfig"
                  :saved_configs="saved_configs"
                  :courseReport="courseReport"
                  :activity_simple_calculation="activity_simple_calculation"
                />
              </div>
              <br />

              <b-row class="m-2">
                <b-button
                  variant="danger"
                  size="sm"
                  @click="$bvModal.show('downloadConfirmation')"
                  >Download Report
                </b-button>

                <b-modal
                  id="downloadConfirmation"
                  no-close-on-backdrop
                  no-close-on-keyboard
                  no-close-on-esc
                  hide-footer
                  size="md"
                >
                  <h3 style="text-align: center">
                    <b
                      >The download will happen without saving the new
                      configuration value</b
                    >
                  </h3>
                  <br />
                  <b-button
                    style="margin-left: 230px"
                    variant="danger"
                    @click="prepareConfigrationForPDFDownload(false, false)"
                    size="sm"
                    >Ok
                  </b-button>
                </b-modal>

                <b-button
                  style="margin-left: 1px"
                  variant="danger"
                  size="sm"
                  @click="prepareConfigrationForPDFDownload(true, false)"
                  >Save & Download Report</b-button
                >
                <b-button
                  style="margin-left: 1px"
                  variant="primary"
                  @click="prepareConfigrationForPDFDownload(true, true)"
                  size="sm"
                  >Save & View Report
                </b-button>
              </b-row>
            </div>
            <br />
          </b-overlay>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AttendenceConfig from "./AttendenceConfig.vue";
import AssignmentConfig from "./AssignmentConfig.vue";
import AssessmentConfig from "./AssessmentConfig.vue";
import FlippedClassConfig from "./FlippedClassConfig.vue";
import WritingTaskConfig from "./WritingTaskConfig.vue";
import SpeakingTaskConfig from "./SpeakingTaskConfig.vue";
import ReadingTaskConfig from "./ReadingTaskConfig.vue";
import QuizConfig from "./QuizConfig.vue";
import ModelsConfig from "./ModelsConfig.vue";
import ListeningTaskConfig from "./ListeningTaskConfig.vue";
import ProjectConfig from "./ProjectConfig.vue";
import SeminarConfig from "./SeminarConfig.vue";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
required;
export default {
  props: ["courseReport"],
  components: {
    AttendenceConfig,
    AssignmentConfig,
    AssessmentConfig,
    FlippedClassConfig,
    WritingTaskConfig,
    ReadingTaskConfig,
    SpeakingTaskConfig,
    QuizConfig,
    ModelsConfig,
    ListeningTaskConfig,
    ProjectConfig,
    SeminarConfig
  },
  async created() {
    //
    this.loadData = true;
    await this.getContinuesEvaluationOptions();
    await this.loadActivityTypes();
    // console.log('parent', this.selectedClassTypes);
    this.loadData = false;
  },
  data() {
    return {
      selectedActivityTypes: [],
      loadConfigData: true,
      loadData: false,
      reportType: 0,
      activity_simple_calculation: false,
      remove_weigtage_column: false,
      description_page: false,
      final_score_roundup: false,
      final_score_rounding: false,

      seminarScore: null,
      seminarCheckBox: false,
      classparticipantScore: null,
      classparticipantCheckBox: false,
      save_config: false,

      classTypes: [],
      selectedClassTypes: [],

      laboratory: {
        checkLab: false,
        assessmentScore: "",
        internalTestScore: "",
        vivaVoceScore: "",
        recordScore: "",
      },
      project: { enable: false, score: "" },
      saved_configs: null,
    };
  },
  methods: {
    async loadActivityTypes() {
      try {
        const res = await this.$axios.get(
          `${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.courseReport.usergroup_id}/activity_types`
        );

        if (Array.isArray(res.data)) {
          this.selectedActivityTypes = res.data;
        } else {
          // default fallback
          this.selectedActivityTypes = ['assessment', 'assignment', 'tutorial'];
        }
      } catch (e) {
        this.selectedActivityTypes = ['assessment', 'assignment', 'tutorial'];
      }
    },
    async getContinuesEvaluationOptions() {
      this.loadConfigData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/continuousevaluation/report/options`;
      await this.$axios
        .post(url, { course: this.courseReport.course_id })
        .then((response) => {
          this.classTypes = response.data.class_types_options;
          // this.selectedClassTypes = this.classTypes.map((option) => option.id);
          // this.selectedClassTypes.push(0);
          this.saved_configs = response.data.saved_config;
        })
        .catch(() => {
          // console.log(error.response);
        });
      if (this.saved_configs != null) {
        this.activity_simple_calculation =
          this.saved_configs.activity_catagory_configs.activity_simple_calculation;
        this.remove_weigtage_column =
          this.saved_configs.activity_catagory_configs.remove_weigtage_column;
        this.description_page = this.saved_configs.description_page;
        this.final_score_roundup = this.saved_configs.final_score_roundup;
        this.final_score_rounding = this.saved_configs.final_score_rounding;

        this.seminarScore = this.saved_configs.seminar_score;
        this.seminarCheckBox = this.saved_configs.enable_seminar;

        this.classparticipantScore = this.saved_configs.classparticipant_score;
        this.classparticipantCheckBox = this.saved_configs.enable_classparticipant;

        this.selectedClassTypes = this.saved_configs.class_types;

        this.laboratory = this.saved_configs.laboratory_config;

        this.project = this.saved_configs.project_config;

        // this.project_with_co = this.saved_configs.project_with_co_configs;
        // this.seminar_with_co = this.saved_configs.seminar_with_co_configs;
        
      }

      this.loadConfigData = false;
    },
    updateActivitySimpleCalculation() {
      // this.$forceUpdate();
    },
    async prepareConfigrationForPDFDownload(save_config, viewReport) {
      this.$bvModal.hide("downloadConfirmation");
      this.loadData = true;

      // Fetch all components
      const attendenceComponent = this.$refs.attendenceConfig;
      const assignmentComponent = this.$refs.assignmentConfig;
      const assessmentComponent = this.$refs.assessmentConfig;
      const flippedClassComponent = this.$refs.flippedClassConfig;
      const writingTaskComponent = this.$refs.writingTaskConfig;
      const speakingTaskComponent = this.$refs.speakingTaskConfig;
      const readingTaskComponent = this.$refs.readingTaskConfig;
      const quizComponent = this.$refs.quizConfig;
      const modelsComponent = this.$refs.modelsConfig;
      const listeningTaskComponent = this.$refs.listeningTaskConfig;
      const projectComponent = this.$refs.projectConfig;
      const seminarComponent = this.$refs.seminarConfig;

      // Run validation checks
      await attendenceComponent.checkValidation();
      if (this.selectedActivityTypes.includes('flipped_class')) {
        await flippedClassComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes("writing_task")) {
        await writingTaskComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes("speaking_task")) {
        await speakingTaskComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes("reading_task")) {
        await readingTaskComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes("quiz")) {
        await quizComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes("models")) {
        await modelsComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes("listening_task")) {
        await listeningTaskComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes('assignment')) {
        await assignmentComponent.checkValidation();
      }
      if (this.selectedActivityTypes.includes('assignment')) {
        await assignmentComponent.checkValidation();
      }
      // If you want project/seminar validation, you can uncomment:
      // await projectComponent.checkValidation();
      // await seminarComponent.checkValidation();

      // Attendance data
      const attendence = {
        checkAttendence: attendenceComponent.attendence.checkAttendence,
        scoreForAttendence: attendenceComponent.attendence.scoreForAttendence,
        date_from: attendenceComponent.attendence.date_from,
        date_upto: attendenceComponent.attendence.date_upto,
        roundAttendenceScoreTo: attendenceComponent.attendence.roundAttendenceScoreTo,
        roundAttendenceScoreDecimals: attendenceComponent.attendence.roundAttendenceScoreDecimals,
        roundAttendenceScoreCustomMapping: attendenceComponent.attendence.roundAttendenceScoreCustomMapping,
        roundAttendenceScoreCustomMappingMale: attendenceComponent.attendence.roundAttendenceScoreCustomMappingMale,
        roundAttendenceScoreCustomMappingFemale: attendenceComponent.attendence.roundAttendenceScoreCustomMappingFemale,
        differentGenderMark: attendenceComponent.attendence. differentGenderMark,
       
      };

      // Assignment data
      let assignment = null;
      if (this.selectedActivityTypes.includes('assignment')){
        assignment = {
          checkAssignment: assignmentComponent.assignment.checkAssignment,
          scoreForAssignment: assignmentComponent.assignment.scoreForAssignment,
          best_of_scores: assignmentComponent.assignment.best_of_scores,
          assignmentData: assignmentComponent.assignmentConfigStructure,
        };
      }
      

      // Assessment data
      let assessment = null;

      if (this.selectedActivityTypes.includes('assessment')) {
        assessment = {
          checkAssessment: assessmentComponent.assessment.checkAssessment,
          scoreForAssessment: assessmentComponent.assessment.scoreForAssessment,
          best_of_scores: assessmentComponent.assessment.best_of_scores,
          assessmentData: assessmentComponent.assessmentConfigStructure,
        };
      }

       // flippedClass data
      let flippedClass = null;

      if (this.selectedActivityTypes.includes('flipped_class')) {
        flippedClass = {
          checkFlippedClass: flippedClassComponent.flippedClass.checkFlippedClass,
          scoreForFlippedClass: flippedClassComponent.flippedClass.scoreForFlippedClass,
          best_of_scores: flippedClassComponent.flippedClass.best_of_scores,
          flippedClassData: flippedClassComponent.flippedClassConfigStructure,
        };
      }

      let writingTask = null;

      if (this.selectedActivityTypes.includes("writing_task")) {
        writingTask = {
          checkWritingTask:
            writingTaskComponent.writingTask.checkWritingTask,
          scoreForWritingTask:
            writingTaskComponent.writingTask.scoreForWritingTask,
          best_of_scores:
            writingTaskComponent.writingTask.best_of_scores,
          writingTaskData:
            writingTaskComponent.writingTaskConfigStructure,
        };
      }

      let speakingTask = null;

      if (this.selectedActivityTypes.includes("speaking_task")) {
        speakingTask = {
          checkSpeakingTask:
            speakingTaskComponent.speakingTask.checkSpeakingTask,
          scoreForSpeakingTask:
            speakingTaskComponent.speakingTask.scoreForSpeakingTask,
          best_of_scores:
            speakingTaskComponent.speakingTask.best_of_scores,
          speakingTaskData:
            speakingTaskComponent.speakingTaskConfigStructure,
        };
      }

      let readingTask = null;

      if (this.selectedActivityTypes.includes("reading_task")) {
        readingTask = {
          checkReadingTask:
            readingTaskComponent.readingTask.checkReadingTask,
          scoreForReadingTask:
            readingTaskComponent.readingTask.scoreForReadingTask,
          best_of_scores:
            readingTaskComponent.readingTask.best_of_scores,
          readingTaskData:
            readingTaskComponent.readingTaskConfigStructure,
        };
      }

      let listeningTask = null;

      if (this.selectedActivityTypes.includes("listening_task")) {
        listeningTask = {
          checkListeningTask:
            listeningTaskComponent.listeningTask.checkListeningTask,
          scoreForListeningTask:
            listeningTaskComponent.listeningTask.scoreForListeningTask,
          best_of_scores:
            listeningTaskComponent.listeningTask.best_of_scores,
          listeningTaskData:
            listeningTaskComponent.listeningTaskConfigStructure,
        };
      }

      let models = null;

      if (this.selectedActivityTypes.includes("models")) {
        models = {
          checkModels: modelsComponent.models.checkModels,
          scoreForModels: modelsComponent.models.scoreForModels,
          best_of_scores: modelsComponent.models.best_of_scores,
          modelsData: modelsComponent.modelsConfigStructure,
        };
      }

      let quiz = null;

      if (this.selectedActivityTypes.includes("quiz")) {
        quiz = {
          checkQuiz: quizComponent.quiz.checkQuiz,
          scoreForQuiz: quizComponent.quiz.scoreForQuiz,
          best_of_scores: quizComponent.quiz.best_of_scores,
          quizData: quizComponent.quizConfigStructure,
        };
      }




      // Project data
      const project = {
        checkProject: projectComponent.project.checkProject,
        scoreForProject: projectComponent.project.projectScore,
        best_of_scores: projectComponent.project.projectBestScore,
        projectData: projectComponent.projectConfigStructure,
      };

      // Seminar data
      const seminar = {
        checkSeminar: seminarComponent.seminar.checkSeminar,
        scoreForSeminar: seminarComponent.seminar.seminarScore,
        best_of_scores: seminarComponent.seminar.seminarBestScore,
        seminarData: seminarComponent.seminarConfigStructure,
      };

      // Prepare post data
      const internalsPostData = {
        save_config: save_config,
        enable_seminar: this.seminarCheckBox,
        seminar_score: this.seminarScore,
        enable_classparticipant: this.classparticipantCheckBox,
        classparticipant_score: this.classparticipantScore,
        final_score_roundup: this.final_score_roundup,
        final_score_rounding: this.final_score_rounding,
        description_page: this.description_page,
        course: this.courseReport.course_id,
        activity_catagory_configs: {
          attendance: {
            enable: attendence.checkAttendence,
            start_date: attendence.date_from ? moment(attendence.date_from).format("YYYY/MM/DD") : null,
            upto_date: attendence.date_upto ? moment(attendence.date_upto).format("YYYY/MM/DD") : null,
            score: attendence.scoreForAttendence,
            round_to: attendence.roundAttendenceScoreTo,
            decimal_count: attendence.roundAttendenceScoreDecimals,
            roundAttendenceScoreCustomMapping: attendence.roundAttendenceScoreCustomMapping,
            roundAttendenceScoreCustomMappingMale: attendence.roundAttendenceScoreCustomMappingMale,
            roundAttendenceScoreCustomMappingFemale: attendence.roundAttendenceScoreCustomMappingFemale,
            differentGenderMark: attendence.differentGenderMark,
          },
          activity_simple_calculation: this.activity_simple_calculation,
          remove_weigtage_column: this.remove_weigtage_column,
          exams: {
            enable: this.selectedActivityTypes.includes("assessment") ? assessment.checkAssessment  : false,
            score: this.selectedActivityTypes.includes("assessment") ? assessment.scoreForAssessment  : null,
            best_of_scores: this.selectedActivityTypes.includes("assessment") ? assessment.best_of_scores  : null,
            resourses: { exam: {} },
          },
          flipped_classes: {
            enable: this.selectedActivityTypes.includes("flipped_class") ? flippedClass.checkFlippedClass  : false,
            score: this.selectedActivityTypes.includes("flipped_class") ? flippedClass.scoreForFlippedClass  : null,
            best_of_scores: this.selectedActivityTypes.includes("flipped_class") ? flippedClass.best_of_scores  : null,
            resourses: { exam: {} },
          },
          writing_tasks: {
            enable: this.selectedActivityTypes.includes("writing_task")
              ? writingTask.checkWritingTask
              : false,

            score: this.selectedActivityTypes.includes("writing_task")
              ? writingTask.scoreForWritingTask
              : null,

            best_of_scores: this.selectedActivityTypes.includes("writing_task")
              ? writingTask.best_of_scores
              : null,

            resourses: { exam: {} },
          },
          speaking_tasks: {
            enable: this.selectedActivityTypes.includes("speaking_task")
              ? speakingTask.checkSpeakingTask
              : false,

            score: this.selectedActivityTypes.includes("speaking_task")
              ? speakingTask.scoreForSpeakingTask
              : null,

            best_of_scores: this.selectedActivityTypes.includes("speaking_task")
              ? speakingTask.best_of_scores
              : null,

            resourses: { exam: {} },
          },
          reading_tasks: {
            enable: this.selectedActivityTypes.includes("reading_task")
              ? readingTask.checkReadingTask
              : false,

            score: this.selectedActivityTypes.includes("reading_task")
              ? readingTask.scoreForReadingTask
              : null,

            best_of_scores: this.selectedActivityTypes.includes("reading_task")
              ? readingTask.best_of_scores
              : null,

            resourses: { exam: {} },
          },
          listening_tasks: {
            enable: this.selectedActivityTypes.includes("listening_task")
              ? listeningTask.checkListeningTask
              : false,

            score: this.selectedActivityTypes.includes("listening_task")
              ? listeningTask.scoreForListeningTask
              : null,

            best_of_scores: this.selectedActivityTypes.includes("listening_task")
              ? listeningTask.best_of_scores
              : null,

            resourses: { exam: {} },
          },
          models: {
            enable: this.selectedActivityTypes.includes("models")
              ? models.checkModels
              : false,

            score: this.selectedActivityTypes.includes("models")
              ? models.scoreForModels
              : null,

            best_of_scores: this.selectedActivityTypes.includes("models")
              ? models.best_of_scores
              : null,

            resourses: { exam: {} },
          },
          quiz: {
            enable: this.selectedActivityTypes.includes("quiz")
              ? quiz.checkQuiz
              : false,

            score: this.selectedActivityTypes.includes("quiz")
              ? quiz.scoreForQuiz
              : null,

            best_of_scores: this.selectedActivityTypes.includes("quiz")
              ? quiz.best_of_scores
              : null,

            resourses: { exam: {} },
          },
          assignments: {
            enable: this.selectedActivityTypes.includes("assignment") ? assignment.checkAssignment : false,
            score: this.selectedActivityTypes.includes("assignment") ? assignment.scoreForAssignment : null,
            best_of_scores: this.selectedActivityTypes.includes("assignment") ? assignment.best_of_scores : null,
            resourses: { exam: {} },
          },
        },
        class_types: attendenceComponent.selectedClassTypes,
        laboratory: this.laboratory,
        project: this.project,
        project_with_co: {
          enable: project.checkProject,
          score: project.scoreForProject,
          best_of_scores: project.best_of_scores,
          resourses: { method: {} },
        },
        seminar_with_co: {
          enable: seminar.checkSeminar,
          score: seminar.scoreForSeminar,
          best_of_scores: seminar.best_of_scores,
          resourses: { method: {} },
        },
      };

      // Populate assignment exam weightages
      if (
        this.selectedActivityTypes.includes("assignment") &&
        assignment &&
        assignment.assignmentData
      ) {
          Object.keys(assignment.assignmentData).forEach((assignmentKey) => {
            const item = assignment.assignmentData[assignmentKey];
            if (item.checkbox) {
              internalsPostData.activity_catagory_configs.assignments.resourses.exam[assignmentKey] = {
                id: assignmentKey,
                persantage_of_wightage: item.input,
              };
            }
        });
      }

      // Populate assessment exam weightages ONLY if assessment is enabled
      if (
        this.selectedActivityTypes.includes("assessment") &&
        assessment &&
        assessment.assessmentData
      ) {
        Object.keys(assessment.assessmentData).forEach((assessmentKey) => {
          const item = assessment.assessmentData[assessmentKey];

          if (item.checkbox) {
            internalsPostData.activity_catagory_configs.exams.resourses.exam[
              assessmentKey
            ] = {
              id: assessmentKey,
              persantage_of_wightage: item.input,
            };
          }
        });
      }

      // Populate flippedClass exam weightages ONLY if flippedClass is enabled
      if (
        this.selectedActivityTypes.includes("flipped_class") &&
        flippedClass &&
        flippedClass.flippedClassData
      ) {
        Object.keys(flippedClass.flippedClassData).forEach((flippedClassKey) => {
          const item = flippedClass.flippedClassData[flippedClassKey];

          if (item.checkbox) {
            internalsPostData.activity_catagory_configs.flipped_classes.resourses.exam[
              flippedClassKey
            ] = {
              id: flippedClassKey,
              persantage_of_wightage: item.input,
            };
          }
        });
      }


      if (
        this.selectedActivityTypes.includes("writing_task") &&
        writingTask &&
        writingTask.writingTaskData
      ) {
        Object.keys(writingTask.writingTaskData).forEach((writingTaskKey) => {
          const item =
            writingTask.writingTaskData[writingTaskKey];

          if (item.checkbox) {
            internalsPostData.activity_catagory_configs
              .writing_tasks.resourses.exam[writingTaskKey] = {
              id: writingTaskKey,
              persantage_of_wightage: item.input,
            };
          }
        });
      }


      if (
        this.selectedActivityTypes.includes("speaking_task") &&
        speakingTask &&
        speakingTask.speakingTaskData
      ) {
        Object.keys(speakingTask.speakingTaskData).forEach(
          (speakingTaskKey) => {
            const item =
              speakingTask.speakingTaskData[speakingTaskKey];

            if (item.checkbox) {
              internalsPostData.activity_catagory_configs
                .speaking_tasks.resourses.exam[speakingTaskKey] = {
                id: speakingTaskKey,
                persantage_of_wightage: item.input,
              };
            }
          }
        );
      }

      if (
        this.selectedActivityTypes.includes("reading_task") &&
        readingTask &&
        readingTask.readingTaskData
      ) {
        Object.keys(readingTask.readingTaskData).forEach((readingTaskKey) => {
          const item =
            readingTask.readingTaskData[readingTaskKey];

          if (item.checkbox) {
            internalsPostData.activity_catagory_configs
              .reading_tasks.resourses.exam[readingTaskKey] = {
              id: readingTaskKey,
              persantage_of_wightage: item.input,
            };
          }
        });
      }

      if (
        this.selectedActivityTypes.includes("listening_task") &&
        listeningTask &&
        listeningTask.listeningTaskData
      ) {
        Object.keys(listeningTask.listeningTaskData).forEach(
          (listeningTaskKey) => {
            const item =
              listeningTask.listeningTaskData[listeningTaskKey];

            if (item.checkbox) {
              internalsPostData.activity_catagory_configs
                .listening_tasks.resourses.exam[listeningTaskKey] = {
                id: listeningTaskKey,
                persantage_of_wightage: item.input,
              };
            }
          }
        );
      }

      if (
        this.selectedActivityTypes.includes("models") &&
        models &&
        models.modelsData
      ) {
        Object.keys(models.modelsData).forEach((modelKey) => {
          const item = models.modelsData[modelKey];

          if (item.checkbox) {
            internalsPostData.activity_catagory_configs.models
              .resourses.exam[modelKey] = {
              id: modelKey,
              persantage_of_wightage: item.input,
            };
          }
        });
      }

      if (
        this.selectedActivityTypes.includes("quiz") &&
        quiz &&
        quiz.quizData
      ) {
        Object.keys(quiz.quizData).forEach((quizKey) => {
          const item = quiz.quizData[quizKey];

          if (item.checkbox) {
            internalsPostData.activity_catagory_configs.quiz
              .resourses.exam[quizKey] = {
              id: quizKey,
              persantage_of_wightage: item.input,
            };
          }
        });
      }


      // Project methods
      Object.keys(project.projectData).forEach((methodKey) => {
        const item = project.projectData[methodKey];
        if (item.checkbox) {
          internalsPostData.project_with_co.resourses.method[methodKey] = {
            id: methodKey,
            persantage_of_wightage: item.input,
          };
        }
      });

      // Seminar methods
      Object.keys(seminar.seminarData).forEach((methodKey) => {
        const item = seminar.seminarData[methodKey];
        if (item.checkbox) {
          internalsPostData.seminar_with_co.resourses.method[methodKey] = {
            id: methodKey,
            persantage_of_wightage: item.input,
          };
        }
      });

      await this.downloadInternalsPDF(internalsPostData, viewReport);
      this.loadData = false;
    },


    async downloadInternalsPDF(internalsPostData, viewReport) {
      this.downloadData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/continuousevaluation/report/pdfexport`;
      await this.$axios
        .post(url, internalsPostData, { responseType: "blob" })
        .then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
          let newTab = null;
          if (viewReport) {
            newTab = window.open(pdfUrl, "_blank");
          }
          if (!newTab) {
            if (viewReport)
              this.$toast.error(
                "Failed to show pdf file, instead the file will be downloaded",
                {
                  position: "top",
                  duration: 3000,
                }
              );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download",`Internal Evaluation Report-${this.courseReport.course_code}-${this.courseReport.usersubgroup_code}-${this.courseReport.usergroup_code}.pdf` )
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          this.downloadData = false;

          // console.log(response);
        })
        .catch((error) => {
          let errorText = "Failed to Download, please check connectivity";
          if (error.response != undefined){
            errorText = "Failed to Download, please try again"
            if (error.response.status == 422){
              errorText = 'Invalid input parameters'
            }
          }
          this.$toast.error(errorText, {
            position: "top",
            duration: 5000,
          });
          this.downloadData = false;
        });
    },
  },
};
</script>
